import React from 'react';
import { Container, Typography, Box, Grid } from '@mui/material';
import { CompareArrows, EmojiEvents, TrendingUp } from '@mui/icons-material';
import PremiumCard from '../components/ui/PremiumCard';
import CompetitiveAnalysisCard from '../components/Dashboard/cards/CompetitiveAnalysisCard';
import { useStoreStats } from '../hooks/useApiWithStore';

/**
 * Página de Análisis Competitivo
 * Benchmarking que Tiendanube no tiene
 */
export default function CompetitiveAnalysis() {
  const { data: statsData, isLoading, error } = useStoreStats();

  if (isLoading) {
    return (
      <Container maxWidth="xl" sx={{ py: 4 }}>
        <Typography>Cargando análisis competitivo...</Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Box mb={4}>
        <Typography variant="h4" fontWeight={700} gutterBottom>
          Análisis Competitivo
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Benchmarking vs industria y análisis de posicionamiento competitivo
        </Typography>
      </Box>

      <Grid container spacing={3}>
        <Grid item xs={12} lg={8}>
          <CompetitiveAnalysisCard statsData={statsData} />
        </Grid>
        
        <Grid item xs={12} lg={4}>
          <PremiumCard
            title="Próximamente"
            subtitle="Análisis Avanzado"
            icon={<EmojiEvents />}
            color="warning"
            exclusive
          >
            <Typography variant="body2" color="text.secondary">
              • Análisis de competidores
              • Monitoreo de precios
              • Análisis de mercado
              • Oportunidades de crecimiento
            </Typography>
          </PremiumCard>
        </Grid>
      </Grid>
    </Container>
  );
}
